import { inspectionNoteBusiness } from "api/bussiness/inspection-note/inspection-note";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type {
  PaginationSearchRequest,
  PaginationSearchResult,
} from "share-components/mui-wrap/auto-complete/x-auto-complete-with-pagination";

export const searchInspectionNoteNumberOptions = async (keyword: string) => {
  const res = await inspectionNoteBusiness.searchInspectionNotes(keyword);
  return mapToDistinctOptionItems(
    res.items?.filter((x) => x.number),
    (x) => x.number,
  );
};

export const searchInspectionNoteNumberOptionsWithPagination = async (
  keyword: string,
  request: PaginationSearchRequest,
): Promise<PaginationSearchResult> => {
  const res = await inspectionNoteBusiness.getLists({
    filter: keyword,
    maxResultCount: request.pageSize,
    skipCount: request.pageIndex * request.pageSize,
    sorting: "",
  });

  return {
    items: mapToDistinctOptionItems(
      res.items?.filter((x) => x.number),
      (x) => x.number,
    ),
    totalCount: res.totalCount,
  };
};
